import { render, staticRenderFns } from "./del-case-batch-number-forever.vue?vue&type=template&id=eefe1fe2&scoped=true"
import script from "./del-case-batch-number-forever.vue?vue&type=script&lang=ts"
export * from "./del-case-batch-number-forever.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefe1fe2",
  null
  
)

export default component.exports